import angular from 'angular';
import ngResource from 'angular-resource';

function DropboxServ($resource) {
	return $resource(
		"/account/dropbox", {
			id: '@id'
		}, {
			'getFolder': {
				method: 'GET',
				url: '/account/dropbox/folder'
			},
			'getFile': {
				method: 'GET',
				url: '/account/dropbox/file'
			},
			'disconnect': {
				method: 'DELETE'
			}
		}
	);
}
DropboxServ.$inject = ['$resource'];

export default angular.module('services.dropbox', [ngResource])
	.factory('Dropbox', DropboxServ)
	.name;



// WEBPACK FOOTER //
// ./project/services/dropbox.js